import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Select from "react-select";
import Collapse from "react-bootstrap/Collapse";
import PageTitle from "../../layouts/PageTitle";
import { deleteCountry, getCountries } from "../../../services/CountryService";
import Swal from "sweetalert2";

const Country = () => {
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const hasFetched = useRef(false);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const location = useLocation();

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  const [data, setData] = useState([]);
  const sort = 10;
  const activePag = useRef(0);
  const [test, settest] = useState(0);

  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };

  const fetchCountries = async (pageNumber = 1, query = "") => {
    try {
      setLoading(true);
      const response = await getCountries(pageNumber, limit, query);
      const { data, pagination } = response.data;
      setCountries(data || []);
      setTotalPages(pagination?.totalPages || 0);
      setTotalItems(pagination?.total || 0);
      setPage(pagination?.page || 1);
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!hasFetched.current) {
      const stateData = location.state;

      if (stateData) {
        setSearchTerm(stateData.searchTerm || "");
        fetchCountries(stateData.page || 1, stateData.searchTerm || "");
      } else {
        fetchCountries(1);
        hasFetched.current = true;
      }
    }
  }, []);

  // --- When data changes, update DOM rows (for pagination)
  useEffect(() => {
    setData(document.querySelectorAll("#country_wrapper tbody tr"));
  }, [countries, test]);

  activePag.current === 0 && chageData(0, sort);

  const handleSearch = () => {
    setPage(1);
    fetchCountries(1, searchTerm);
  };

  const handleReset = () => {
    setSearchTerm("");
    setPage(1);
    fetchCountries(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
      fetchCountries(newPage, searchTerm);
    }
  };

  const handleDeleteCountry = (countryId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once status changed!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: `${status ? "#dd6b55" : "#4caf50"}`,
      cancelButtonColor: "#aaa",
      confirmButtonText: "Yes, change it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Call your delete API here
          await deleteCountry(countryId); // make sure you have a deleteCountry function
          Swal.fire("Suceess!", "Country status has been changed.", "success");
          // Refresh the list
          fetchCountries(page, searchTerm);
        } catch (error) {
          Swal.fire("Error!", "Failed to change country status.", "error");
        }
      }
    });
  };

  return (
    <>
      <PageTitle
        activeMenu="Country"
        motherMenu="Country"
        activeMenuLink={"country"}
        motherMenuLink={"country"}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`} onClick={() => setOpen(!open)}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-3 col-sm-6">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control mb-3 mb-xl-0"
                        id="exampleFormControlInput1"
                        placeholder="Search by name..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                    <div className="col-xl-3 col-sm-6 align-self-end">
                      <button
                        className="btn btn-primary me-2 rounded-sm"
                        title="Click here to Search"
                        type="button"
                        onClick={handleSearch}
                      >
                        <i className="fa fa-search me-1"></i>Filter
                      </button>
                      <button
                        className="btn btn-danger light rounded-sm"
                        title="Click here to remove filter"
                        type="button"
                        onClick={handleReset}
                      >
                        <i className="fa fa-undo me-1"></i>
                        Remove Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
          <div className="mb-4 pb-3">
            <ul className="d-flex align-items-center flex-wrap">
              <li>
                <Link to={"/add-country"} className="btn btn-sm btn-primary ">
                  Add Country
                </Link>
              </li>
            </ul>
          </div>
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`} onClick={() => setOpen2(!open2)}>
              <div className="cpa">
                <i className="flaticon-381-controls-5 me-1" />
                Country List
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body py-3">
                  {loading ? (
                    <p>Loading...</p>
                  ) : (
                    <div className="table-responsive order-list-table">
                      <div
                        id="country_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table className="table table-responsive-lg table-condensed flip-content">
                          <thead>
                            <tr>
                              <th className="text-black">S.No</th>
                              <th className="text-black">Name</th>
                              <th className="text-black">Status</th>
                              <th className="text-black">Created</th>
                              <th className="text-black text-end">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {countries.length > 0 ? (
                              countries.map((item, ind) => (
                                <tr key={ind}>
                                  <td>{(page - 1) * limit + ind + 1}</td>
                                  <td className="truncate">{item.name}</td>
                                  <td>
                                    <span
                                      className={`badge d-inline-block text-capitalize ${item.status
                                          ? "bg-success"
                                          : !item.status
                                            ? "bg-secondary"
                                            : "bg-warning"
                                        }`}
                                    >
                                      {item.status ? "Active" : "Inactive"}
                                    </span>
                                  </td>
                                  <td>
                                    {new Date(
                                      item.createdAt
                                    ).toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    })}
                                  </td>
                                  <td className="text-end">
                                    <Link
                                      to={`/edit-country/${item.id}`}
                                      state={{ page, searchTerm }}
                                      className="btn btn-warning btn-sm content-icon me-1"
                                    >
                                      <i className="fa fa-edit"></i>
                                    </Link>
                                    <Link
                                      to={"#"}
                                      className={`${!item.status
                                          ? "btn btn-success btn-sm content-icon ms-1"
                                          : "btn btn-danger btn-sm content-icon ms-1"
                                        }`}
                                      onClick={() =>
                                        handleDeleteCountry(
                                          item.id,
                                          item.status
                                        )
                                      }
                                    >
                                      <i
                                        className={`${!item.status
                                            ? "fa-solid fa-plus"
                                            : "fa-solid fa-minus"
                                          }`}
                                      />
                                    </Link>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5" className="text-center">
                                  No countries found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        {totalPages > 0 && (
                          <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                            <div className="dataTables_info">
                              {totalItems > 0 && (
                                <>
                                  Showing {(page - 1) * limit + 1} to{" "}
                                  {Math.min(page * limit, totalItems)} of{" "}
                                  {totalItems} entries
                                </>
                              )}
                            </div>

                            <div
                              className="dataTables_paginate paging_simple_numbers"
                              id="example2_paginate"
                            >
                              {/* Prev button */}
                              <Link
                                className={`paginate_button previous ${page === 1 ? "disabled" : ""
                                  }`}
                                to="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (page > 1) handlePageChange(page - 1);
                                }}
                              >
                                <i className="fa fa-angle-double-left" />
                              </Link>

                              <span>
                                {Array.from(
                                  { length: totalPages },
                                  (_, i) => i + 1
                                )
                                  .filter((i) => {
                                    // Always show first 2 and last 2
                                    if (i <= 2 || i > totalPages - 2)
                                      return true;
                                    // Show nearby pages of the current one
                                    if (Math.abs(page - i) <= 1) return true;
                                    return false;
                                  })
                                  .reduce((acc, i, index, arr) => {
                                    // Add ellipsis between distant page numbers
                                    if (index > 0 && i - arr[index - 1] > 1)
                                      acc.push("ellipsis");
                                    acc.push(i);
                                    return acc;
                                  }, [])
                                  .map((item, index) =>
                                    item === "ellipsis" ? (
                                      <span
                                        key={index}
                                        className="paginate_button disabled"
                                      >
                                        ...
                                      </span>
                                    ) : (
                                      <Link
                                        key={index}
                                        to="#"
                                        className={`paginate_button ${page === item ? "current" : ""
                                          }`}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handlePageChange(item);
                                        }}
                                      >
                                        {item}
                                      </Link>
                                    )
                                  )}
                              </span>

                              {/* Next button */}
                              <Link
                                className={`paginate_button next ${page === totalPages ? "disabled" : ""
                                  }`}
                                to="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (page < totalPages) handlePageChange(page + 1);
                                }}
                              >
                                <i className="fa fa-angle-double-right" />
                              </Link>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};
export default Country;
